<form [formGroup]="formGroup">
	<div class="copo-container">
		<div class="copo-section">
			<div class="copo-section-header">
				<span translate>feasibiliy-characteristics</span>
			</div>
		</div>
		<div class="copo-section-body copo-grid" *ngIf="productCategories && productCategories.length > 0">
			<div class="copo-grid-row">
				<!-- Sold To Field -->
				<div class="copo-grid-row-column-1">
					<mat-form-field class="copo-form-field">
						<mat-label translate>guarantee.customer.name</mat-label>
						<mat-select required formControlName="soldToName"
							(selectionChange)="onSoldToNameChange()">
							<mat-option *ngFor="let soldTo of soldTos" [value]="soldTo.businessId">
								{{ soldTo.name }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="formGroup.get('soldToName')?.hasError('required')">
							<span translate>guarantee.corporate.name.mandatory</span>
						</mat-error>
					</mat-form-field>
				</div>

				<!-- Product Category Field -->
				<div class="copo-grid-row-column-2">
					<mat-form-field class="copo-form-field">
						<mat-label translate>datacenter-filter.product-category</mat-label>
						<mat-select required formControlName="productCategory"
							(selectionChange)="onProductCategoryChange()">
							<mat-option *ngFor="let category of productCategories" [value]="category.productCategoryCode">
								{{ category.productCategory }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="formGroup.get('productCategory')?.hasError('required')">
							<span translate>warning-product-category</span>
						</mat-error>
					</mat-form-field>
				</div>

				<!-- Product Sub Category Field -->
				<div class="copo-grid-row-column-3">
					<mat-form-field class="copo-form-field">
						<mat-label translate>datacenter.offer.subcategory</mat-label>
						<mat-select required formControlName="productSubCategory"
							(selectionChange)="onSubCategoryChange()">
							<mat-option *ngFor="let category of productSubCategories" [value]="category.productSubCategoryCode">
								{{ category.productSubCategory }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="formGroup.get('productSubCategory')?.hasError('required')">
							<span translate>warning-sub-category</span>
						</mat-error>
					</mat-form-field>
				</div>

				<!-- Standard Steelgrade Field -->
				<div class="copo-grid-row-column-4">
					<mat-form-field class="copo-form-field">
						<mat-label translate>standard-steelgrade</mat-label>
						<mat-select formControlName="standardSteelgrade"
							(selectionChange)="onStandardSteelgradeChange()" required>
							<mat-option *ngFor="let grade of filteredStandardSteelgrades" [value]="grade">
								{{ grade }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="formGroup.get('standardSteelgrade')?.hasError('required')">
							<span translate>warning-standard-steelgrade</span>
						</mat-error>
					</mat-form-field>
				</div>

				<!-- Steelgrade Field -->
				<div class="copo-grid-row-column-5">
					<mat-form-field class="copo-form-field">
						<mat-label translate>dashboard.steelgrade</mat-label>
						<mat-select formControlName="steelgrade" (selectionChange)="onSteelgradeChange()" required>
							<mat-option *ngFor="let grade of filteredSteelgrades" [value]="grade">
								{{ grade }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="formGroup.get('steelgrade')?.hasError('required')">
							<span translate>warning-steelgrade</span>
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<div class="copo-section-body copo-grid">
				<div class="copo-grid-row">
					<!-- Width Field -->
					<div class="copo-grid-row-column-1">
						<mat-form-field class="copo-form-field">
							<mat-label translate>shipment.filter.width</mat-label>
							<input type="number" matInput formControlName="width" required
								(input)="onWidthChange($event)"/>
							<mat-error *ngIf="formGroup.get('width')?.hasError('required')">
								<span translate>warning-width</span>
							</mat-error>
							<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix></mat-icon>
						</mat-form-field>
					</div>

					<!-- Thickness Field -->
					<div class="copo-grid-row-column-2">
						<mat-form-field class="copo-form-field">
							<mat-label translate>shipment.filter.thickness</mat-label>
							<input type="number" matInput formControlName="thickness" required
								(input)="onThicknessChange($event)"/>
							<mat-error *ngIf="formGroup.get('thickness')?.hasError('required')">
								<span translate>warning-thickness</span>
							</mat-error>
							<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix></mat-icon>
						</mat-form-field>
					</div>

					<!-- Request Feasibility Button -->
					<div class="copo-grid-row-column-3">
						<button type="button" mat-flat-button color="primary" class="next-button"
							(click)="onRequestFeasibility()" [disabled]="!getButtonStatus() || !isSubmitDisabled">
							<ng-container *ngIf="!isRequesting">
								<span translate>request-feasibility</span>
							</ng-container>
							<copo-loading-spinner *ngIf="isRequesting"></copo-loading-spinner>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
<div *ngIf="showResults">
	<div class="card-title-block-non-sticky batches-title">
		<div class="card-title-label" translate>feasible-results</div>
	</div>
	<div class="feasibility-wrapper card-info-block">
		<div class="card-disclaimer-label" translate>efeasibility-disclaimer</div>
		<div class="card-disclaimer-label" translate>efeasibility-disclaimer.end</div>
		<div class="export-result">
			<div class="export-result-content">
				<div class="export-result-label">
					<span translate
						[translateParams]="{ value: filteredCount | copoNumber:'number' }">datacenter.results</span>
				</div>
				<div class="icon-wrapper" *ngIf="canDownload() && !exportInProgress">
					<mat-icon color="accent" svgIcon="md:download" (click)="onBtExport()" [title]="'sb.Download' | translate"></mat-icon>
				</div>
				<copo-loading-spinner *ngIf="exportInProgress"></copo-loading-spinner>
			</div>
		</div>
		<div class="copo-card-grid-container">
			<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridOptions" [modules]="clientSideModules"
				(gridReady)="onGridReady($event)" (viewportChanged)="onViewportChanged($event)">
			</ag-grid-angular>
		</div>
	</div>
</div>